import { css } from '@inter-ikea-kompis/web-component';
export default class WaterLabelCardStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme ...
     * @returns Styles.
     */
    static getStyle(options) {
        return css `
			.container {
				display: flex;
				flex-direction: column;
			}
			.labels {
				flex-wrap: wrap;
				display: flex;
				justify-content: center;
				max-width: 100%;
			}
			img {
				outline: none;
				width: 90%;
			}
			.labels > * {
				margin: ${options.theme.spacing.space50 / 16}rem;
				overflow: hidden;
				width: 100%;
				display: flex;
				justify-content: center;
			}
		`;
    }
}
//# sourceMappingURL=WaterLabelCardStyle.js.map